<template>
    <div class="top-container">
        <el-breadcrumb class="app-breadcrumb" separator="/">
            <transition-group name="breadcrumb">
                <el-breadcrumb-item v-for="(item, index) in titleList" :key="item">
                    <span v-if="index == titleList.length - 1">{{ item }}</span>
                    <span v-else style="font-weight: bold;">{{ item }}</span>
                </el-breadcrumb-item>
            </transition-group>
        </el-breadcrumb>
        <div class="rule">
            <a href="https://www.ddky.com/word/rule.html?ddkycache=4e5c93d16a6f226e28e835e9ad97353a" target="_blank">叮当快药开放平台总则</a>
        </div>
    </div>
</template>

<script>
import pathToRegexp from 'path-to-regexp'

export default {
    data() {
        return {
            titleList: []
        }
    },
    watch: {
        $route() {
            this.getBreadcrumb()
        }
    },
    created() {
        this.getBreadcrumb()
    },
    methods: {
        getBreadcrumb() {
            this.titleList = []
            this.$route.matched.forEach(item => {
                if (Object.prototype.toString.call(item.meta.title) === '[object Array]') {
                    this.titleList = this.titleList.concat(item.meta.title)
                } else if (item.meta.title) {
                    this.titleList.push(item.meta.title)
                }
            })
        },
        pathCompile(path) {
            // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
            const { params } = this.$route
            var toPath = pathToRegexp.compile(path)
            return toPath(params)
        },
        // eslint-disable-next-line no-unused-vars
        handleLink(item) {
            return false
            // const { redirect, path } = item
            // if (redirect) {
            //   this.$router.push(redirect)
            //   return
            // }
            // this.$router.push(this.pathCompile(path))
        }
    }
}
</script>

<style lang="scss" scoped>
.top-container {
    display: flex;
    align-items: center;
}
.rule {
    float: right;
    width: 85%;
    text-align: right;
    a {
        color: red;
    }
}
.app-breadcrumb.el-breadcrumb {
    display: inline-block;
    font-size: 14px;
    display: flex;
    line-height: 60px;
    margin-left: 10px;
    .no-redirect {
        color: #97a8be;
        cursor: text;
    }
}
// 去除小手和颜色变更效果
.el-breadcrumb__inner.is-link:hover,
.el-breadcrumb__inner a:hover {
    color: #303133;
}
.right-info {
    float: right;
    font-size: 14px;
    line-height: 50px;
    color: #606266;
    span {
        margin-right: 20px;
    }
}
</style>
